import React from "react";
import { observer, inject } from "mobx-react";
import { Row, Col, Table, Button, Form, Card, FormCheck, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { STORE_CUSTOMER_ORDERS } from "../../../constants";
import { RouteComponentProps } from "react-router-dom";
import { CustomerOrdersStore, CustomerOrderShortDetails } from "../../../stores";
import { formatDate, formatMoney, formatShortDate } from "../../../common/Formatting";
import { wrapCheckbox, wrapInput } from "../../../common/FormChangeWrapper";

interface IProps {
    isOpened: boolean,
    onClose: () => void,
    onCacheInAdded: (sum: number) => void,
    orderId: number,
    maxSum: number,
    payedSum: number,
    orderSum: number
}

interface IState {
    sum?: number
}


type Props = IProps;

@inject(STORE_CUSTOMER_ORDERS)
@observer
export class AddPaymentModal extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        this.state = {
        };
    }

    ordersStore = (this.props as any)[STORE_CUSTOMER_ORDERS] as CustomerOrdersStore;

    componentDidMount() {
    }

    componentDidUpdate(prevProps: Props, prevState: IState, snapshot: any) {
        if (this.props.isOpened && (!prevProps.isOpened || prevProps.maxSum != this.props.maxSum)) {
            this.setState({
                sum: undefined
            })
        }
    }

    private savePayment = () => {
        this.ordersStore.addCacheInPaymentByOrder(this.props.orderId, this.state.sum || 0, () => {
            this.props.onCacheInAdded(this.state.sum || 0);
            this.props.onClose();
        });
    }

    private onChangeSum = (fieldName: string, value: string) => {
        const checkedValue = parseFloat(value) > this.props.maxSum ? this.props.maxSum : parseFloat(value);
        this.setState({
            sum: checkedValue
        });
    }

    render() {
        return <Modal show={this.props.isOpened} onHide={this.props.onClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>
                    Внесение оплаты по заказу №{this.props.orderId}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form inline onSubmit={(e: any) => {
                    e.preventDefault();
                }}>
                    <Form.Group controlId="formSearch">
                        <Form.Control size="sm"
                            type="number" value={this.state.sum != undefined ? this.state.sum.toString() : ""}
                            onChange={wrapInput(this.onChangeSum)}
                            placeholder={`Введите сумму оплаты... Максимально ${formatMoney(this.props.maxSum)} руб.`}
                            style={{ width: "400px", marginRight: "20px" }}
                            autoComplete="off" />
                            Сумма заказа {formatMoney(this.props.orderSum)} руб. Уже оплачено {formatMoney(this.props.payedSum)} руб.
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.props.onClose}>
                    Отмена
                </Button>
                <Button variant="primary" onClick={this.savePayment}>
                    <FontAwesomeIcon icon="save" /> {' '}
                    Сохранить платеж
                </Button>
            </Modal.Footer>
        </Modal>
    }
}